import React from 'react'

const normalizeButtonLabel = (label: React.ReactNode) => {
  if (typeof label !== 'string') {
    return undefined
  }

  return label
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export const getButtonTestId = ({
  fallback,
  id,
  label,
  testId,
}: {
  fallback: string
  id?: string
  label?: React.ReactNode
  testId?: string
}) => {
  if (testId) {
    return testId
  }

  if (id) {
    return `button-${id}`
  }

  const normalizedLabel = normalizeButtonLabel(label)

  return normalizedLabel ? `button-${normalizedLabel}` : fallback
}
